module.exports = __webpack_public_path__ + "static/media/User.f0b49e3f.svg";